import { useEffect, useState } from "react";

const navLinks = [
  { label: "实时快报", href: "#live" },
  { label: "进展时间线", href: "#timeline" },
  { label: "话题榜", href: "#rank" },
  { label: "频道", href: "#channels" },
  { label: "常见问题", href: "#faq" },
  { label: "关于", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-all duration-300 " +
        (scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0] shadow-background-200"
          : "bg-transparent")
      }
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-16">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜前线 首页">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
            <i className="ri-flashlight-fill"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-900">
            吃瓜<span className="text-primary-600">前线</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm whitespace-nowrap text-foreground-700 hover:text-primary-600 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#timeline"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 border border-background-300 px-4 py-2 text-sm text-foreground-800 hover:border-primary-300 transition-colors"
          >
            <i className="ri-refresh-line"></i>
            手动刷新
          </a>
          <a
            href="#channels"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm hover:bg-primary-600 transition-colors"
          >
            <i className="ri-fire-fill"></i>
            追最新瓜
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-800"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50/95 backdrop-blur border-t border-background-200 px-4 py-3 fade-up">
          <div className="flex flex-col">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-sm text-foreground-800 hover:text-primary-600 border-b border-background-100 last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#channels"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm"
            >
              追最新瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}